import * as React from "react"
import type { SVGProps } from "react"
const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18 15.9q0 2.6-1.82 4.42a6 6 0 0 1-4.43 1.82q-2.6 0-4.42-1.82a6 6 0 0 1-1.83-4.43V6.64q0-1.87 1.31-3.18C8.12 2.15 8.75 2.14 10 2.14q1.87 0 3.19 1.31a4.3 4.3 0 0 1 1.31 3.2v8.74q0 1.16-.8 1.95-.8.8-1.95.8a2.7 2.7 0 0 1-1.95-.8A2.7 2.7 0 0 1 9 15.4V7.14q0-.42.29-.71a1 1 0 0 1 .71-.29.97.97 0 0 1 1 1v8.25a.73.73 0 0 0 .75.75.73.73 0 0 0 .75-.75V6.64q-.03-1.05-.74-1.77-.7-.73-1.76-.73c-1.06 0-1.3.25-1.77.73a2.4 2.4 0 0 0-.73 1.77v9.25a4 4 0 0 0 1.23 3.02 4 4 0 0 0 3.02 1.23q1.75 0 2.98-1.23A4.3 4.3 0 0 0 16 15.89V7.14q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.3.29.71z" />
  </svg>
)
export default SvgAttachment
